import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BamboraPaymentCardService } from '../../../providers/bambora-payment-card.service';
import { Bambora_credit_card } from '../../../models/accounting/banking/bambora_credit_card';
import { BamboraModalAddPaymentMethodComponent } from '../bambora-modal-add-payment-method/bambora-modal-add-payment-method.component';
import { faCreditCard, faPlus, faDotCircle } from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-bambora-choose-payment-method',
  templateUrl: './bambora-choose-payment-method.component.html',
  styleUrls: ['./bambora-choose-payment-method.component.css']
})
export class BamboraChoosePaymentMethodComponent implements OnInit {

  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faDotCircle = faDotCircle;

  payment_methods: Bambora_credit_card[] = [];

  @Output() payment_method_selected$: EventEmitter<Bambora_credit_card> = new EventEmitter<Bambora_credit_card>();
  @Output() error$: EventEmitter<string> = new EventEmitter<string>();
  @Input() competition_organizer_id: string;

  constructor(private modal: NgbModal, private bamboraPaymentCardService: BamboraPaymentCardService) { }

  ngOnInit(): void {
    this.bamboraPaymentCardService.get_list(this.competition_organizer_id).then(cards => {
      this.payment_methods = cards;
      if (cards.length > 0) {
        cards[0].selected = true;
        this.payment_method_selected$.emit(cards[0]);
      }
    }).catch(error => {
      this.error$.emit(error);
    });
  }

  onSelectCard(card: Bambora_credit_card) {
    this.payment_methods.forEach(c => c.selected = false);
    card.selected = true;
    this.payment_method_selected$.emit(card);
  }

  addPaymentMethod() {
    const modal_ref = this.modal.open(BamboraModalAddPaymentMethodComponent, { size: 'lg' });
    modal_ref.componentInstance.organizer_id = this.competition_organizer_id;

    modal_ref.componentInstance.credit_card_created$.subscribe((card: Bambora_credit_card) => {
      card.selected = true;
      this.payment_methods.forEach(c => c.selected = false);
      this.payment_methods.push(card);
      this.payment_methods.sort((a, b) => {
        if (a.cardholder_name < b.cardholder_name) return -1;
        if (a.cardholder_name > b.cardholder_name) return 1;
        return 0;
      });
      this.payment_method_selected$.emit(card);
      modal_ref.close();
    }, error => {
      this.error$.emit(error);
    });
  }

}
